<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs4-08",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 60,
      nextPage: '/excessive',
      // nextPage: '/questionnaire/section4/8',
      navigateType: 'CLICK_NEXT',
      content: {
        layout: 'layout_left',
        componentsType: {
          pc: 'labelBtn',
          mobile: 'labelBtn'
        },
        mainTitle: 'Last question! How did you hear about us?',
        subTitle: 'Select all that apply.',
        btn: [
          [
            {
              text: 'Amazon',
            },{
              text: 'Instagram',
            }
          ],[
            {
              text: 'Tiktok',
            },{
              text: 'From a friend',
            }
          ],[
            {
              text: 'Online search',
            }
          ]
        ],
        hasInput: true
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
#qs57{
  .layout_left{
    .btnBlockRow{
      width: 100%;
      justify-content: space-between;
    }
  }
}
</style>
